import { LevelRow } from '../types/survey';
import { normalizeOCRText } from './ocrCorrections';

function id() {
  return Date.now().toString() + Math.random().toString(36).slice(2);
}

function blank(data: Partial<LevelRow>): LevelRow {
  return {
    id: id(),
    chainage: '',
    offset: '',
    side: 'Center',
    bs: '',
    is: '',
    fs: '',
    hi: '',
    ch: '',
    offsetSigned: '',
    rl: '',
    tbmValue: '',
    remarks: '',
    ...data
  };
}

export function parseFieldBookText(text: string): LevelRow[] {
  const rows: LevelRow[] = [];
  let currentChainage = '';

  for (const raw of text.split('\n')) {
    const line = normalizeOCRText(raw);
    console.log('NORMALIZED:', line);
    if (!line) continue;

    const ch = line.match(/\b(?:CH|CHAINAGE|KM)?\s*(\d{1,4}\+\d{1,4}|\d{5,7})\b/);
    if (ch) currentChainage = ch[1];

    const bs = line.match(
  /\bBS\s*([0-5]\.\d{2,3})\b/
);

const isv = line.match(
  /\bIS\s*([0-5]\.\d{2,3})\b/
);

const fs = line.match(
  /\bFS\s*([0-5]\.\d{2,3})\b/
);
    const tbm = line.match(/\b(?:TBM|BM).*?RL\s*[:=]?\s*([0-9]+(?:\.[0-9]+)?)\b/);
    const validReading = (v?: string) =>
  !!v &&
  parseFloat(v) >= 0.5 &&
  parseFloat(v) <= 5.0;

  const hasData =
  validReading(bs?.[1]) ||
  validReading(isv?.[1]) ||
  validReading(fs?.[1]) ||
  tbm ||
  line.includes('CP');

  if (!hasData) {

  const surveyValues =
  (line.match(/\d+\.\d{3}/g) || [])
    .filter(n => {
      const v = parseFloat(n);
      return v >= 0.5 && v <= 5.0;
    });

  if (surveyValues.length > 0) {

    rows.push(
      blank({
        chainage: currentChainage,
        ch: currentChainage,
        is: surveyValues[0]
      })
    );

  }

  continue;
}
   const bsVal =
  validReading(bs?.[1]) ? bs![1] : '';

const isVal =
  validReading(isv?.[1]) ? isv![1] : '';

const fsVal =
  validReading(fs?.[1]) ? fs![1] : '';

if (!bsVal && !isVal && !fsVal && !tbm)
  continue;

rows.push(blank({
  chainage: currentChainage,
  ch: currentChainage,
  bs: bsVal,
  is: isVal,
  fs: fsVal,
  tbmValue: tbm?.[1] ?? '',
  remarks: tbm ? 'TBM' : ''
}));
  }
console.log(
  "FIELD BOOK PARSER OUTPUT",
  JSON.stringify(rows, null, 2)
);

  return rows;
}
